module.exports = __webpack_public_path__ + "img/logo.434df351.png";